import { Record } from "immutable";

export type SectionStatType = {
  bestScore?: number;
  worstScore?: number;
  averageScore?: number;
  firstScore?: number;
  lastScore?: number;
  sessionsCompleted?: number;
  totalStudyTime?: number;
};

export const defaultSectionStat: SectionStatType = {
  bestScore: undefined,
  worstScore: undefined,
  averageScore: undefined,
  firstScore: undefined,
  lastScore: undefined,
  sessionsCompleted: undefined,
  totalStudyTime: undefined
};

export default class SectionStat extends Record(defaultSectionStat) {}
